import { render, staticRenderFns } from "./RecommendGoods.vue?vue&type=template&id=da36d678&scoped=true"
import script from "./RecommendGoods.vue?vue&type=script&lang=js"
export * from "./RecommendGoods.vue?vue&type=script&lang=js"
import style0 from "./RecommendGoods.vue?vue&type=style&index=0&id=da36d678&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da36d678",
  null
  
)

export default component.exports